import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'styled-components';
import formatCardName from '@upgrade/ui-utils/formatters/pcl/card-name';
import { CRB, SUTTON } from '@upgrade/ui-utils/constants/pcl/issuing-bank';
import { BITCOIN_PROGRAM_DEFINITION_CODES, LENDING_TREE_PROGRAM_DEFINITION_CODES } from '@upgrade/ui-utils/constants/pcl/program-definition-code';
import Text from '../../Typography/Text';
import Link from '../../Link';
import * as Types from '../types';
const {
  HOME_IMPROVEMENT_CREDIT_LINE,
  NONE,
  PERSONAL_LOAN,
  PERSONAL_CREDIT_LINE,
  AUTO_REFINANCE,
  REWARDS_CHECKING,
  ALL_PRODUCTS,
  LENDING_TREE,
  AUTO_FINANCE
} = Types;

// eslint-disable-next-line react/prop-types
const PersonalLoan = ({
  withAutoRefinance,
  publicSiteUrl = ''
}) => {
  const theme = useTheme();
  const text = withAutoRefinance ? theme.footerBankNoticePersonalLoanWithAutoRefinanceText : theme.footerBankNoticePersonalLoanText;
  return /*#__PURE__*/React.createElement(React.Fragment, null, text, /*#__PURE__*/React.createElement(Link, {
    type: "text",
    inherit: true,
    href: `${publicSiteUrl}/bank-partners/`
  }, "bank partners"), ".");
};
const ISSUING_BANK_LABEL = {
  [CRB]: 'Cross River Bank, Member FDIC',
  [SUTTON]: 'Sutton Bank, Member FDIC'
};
const PersonalCreditLine = ({
  publicSiteUrl,
  withNydigNotice,
  programDefinitionCode,
  cardIssuingBanks = [CRB]
}) => {
  const cardName = formatCardName({
    code: programDefinitionCode
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, "Personal Credit Lines are issued by Cross River Bank, a New Jersey State Chartered Commercial Bank, Member FDIC, Equal Housing Lender. ", cardIssuingBanks.length > 1 ? `All ${cardName}s are` : `The ${cardName} is`, " issued by", ' ', cardIssuingBanks.map(cardIssuingBank => ISSUING_BANK_LABEL[cardIssuingBank]).join(', or '), ", pursuant to a license from Visa U.S.A. Inc.", ' ', /*#__PURE__*/React.createElement(Link, {
    type: "text",
    inherit: true,
    href: "https://upgrade.zendesk.com/hc/en-us/articles/115005202407--Is-Upgrade-a-bank-"
  }, "Get more info"), ".", ' ', withNydigNotice || BITCOIN_PROGRAM_DEFINITION_CODES.includes(programDefinitionCode) ? /*#__PURE__*/React.createElement(React.Fragment, null, "Bitcoin services and accounts provided by NYDIG. NYDIG is licensed to engage in Virtual Currency Business Activity by the New York State Department of Financial Services. See", ' ', /*#__PURE__*/React.createElement(Link, {
    type: "text",
    inherit: true,
    href: `${publicSiteUrl}/funnel/borrower-documents/NYDIG_TERMS_AND_CONDITIONS?productType=PERSONAL_CREDIT_LINE`
  }, "NYDIG Terms"), ".") : null, LENDING_TREE_PROGRAM_DEFINITION_CODES.includes(programDefinitionCode) ? `Upgrade is the servicer of the Win Card with Personal Credit Line.` : null);
};
const LendingTreeCredit = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
  as: "p"
}, "Personal Credit Lines are issued by Cross River Bank, Member FDIC. The Upgrade Card associated with a Personal Credit Line is issued by Sutton Bank, Member FDIC, or Cross River Bank, Member FDIC, pursuant to licenses from Visa U.S.A. Inc. The LendingTree Win Card is issued by Sutton Bank, Member FDIC, pursuant to a license from Visa U.S.A. Inc. Upgrade is the servicer of the Win Card with Personal Credit Line."), /*#__PURE__*/React.createElement(Text, {
  as: "p"
}, "Upgrade, Inc. (NMLS #1548935) holds the following", ' ', /*#__PURE__*/React.createElement(Link, {
  openInNewWindow: true,
  href: "https://link.upgrade.com/f/a/dTCICLkrvjbHk2CU3IhoCQ~~/AAQRxQA~/RgRm0hVpP0RsaHR0cHM6Ly91cGdyYWRlLnplbmRlc2suY29tL2hjL2VuLXVzL2FydGljbGVzLzQ0MDQ0MTYzNjA3MzEtT3ZlcnZpZXctU3RhdGUtTGljZW5zZXMtYW5kLUNvbnN1bWVyLUluZm9ybWF0aW9uVwNzcGNCCmTnaZDvZLFksVpSFHNkYW5nZWxvQHVwZ3JhZGUuY29tWAQAAAIV"
}, "state licenses"), ' ', "and does business under the following", ' ', /*#__PURE__*/React.createElement(Link, {
  openInNewWindow: true,
  href: "https://link.upgrade.com/f/a/sc8HRK73CPzLs7gnw6oZuQ~~/AAQRxQA~/RgRm0hVpP0QcaHR0cHM6Ly93d3cudXBncmFkZS5jb20vZGJhL1cDc3BjQgpk52mQ72SxZLFaUhRzZGFuZ2Vsb0B1cGdyYWRlLmNvbVgEAAACFQ~~"
}, "DBAs"), "."), /*#__PURE__*/React.createElement(Text, {
  as: "p"
}, "Upgrade is a", ' ', /*#__PURE__*/React.createElement(Link, {
  openInNewWindow: true,
  href: "https://link.upgrade.com/f/a/iCK5pWub54X45jGt9-kNAA~~/AAQRxQA~/RgRm0hVpP0ROaHR0cHM6Ly91cGdyYWRlLnplbmRlc2suY29tL2hjL2VuLXVzL2FydGljbGVzLzExNTAwNTIwMjQwNy0tSXMtVXBncmFkZS1hLWJhbmstVwNzcGNCCmTnaZDvZLFksVpSFHNkYW5nZWxvQHVwZ3JhZGUuY29tWAQAAAIV"
}, "financial technology company, not a bank"), "."));
const RewardsChecking = ({
  withDeposit = false
}) => /*#__PURE__*/React.createElement(React.Fragment, null, "Upgrade is a financial technology company, not a bank.", ' ', withDeposit ? 'Checking and savings accounts' : 'Rewards Checking services', " provided by Cross River Bank, Member FDIC. Upgrade VISA\xAE Debit Cards issued by Cross River Bank, Member FDIC, pursuant to a license from Visa U.S.A. Inc.");
const AutoRefinance = ({
  publicSiteUrl = ''
}) => /*#__PURE__*/React.createElement(React.Fragment, null, "Auto Refinance Loans made by Upgrade's", ' ', /*#__PURE__*/React.createElement(Link, {
  type: "text",
  inherit: true,
  href: `${publicSiteUrl}/bank-partners/`
}, "bank partners"), ".");
const AutoFinance = () => /*#__PURE__*/React.createElement(React.Fragment, null, "Dealerships in Upgrade's network can assign retail installment sale contracts to Upgrade.");
const HomeImprovement = () => /*#__PURE__*/React.createElement(React.Fragment, null, "Home Improvement Loans are made by Cross River Bank, Member FDIC, Equal Housing Lender.");
const BankNoticeV1 = ({
  type,
  publicSiteUrl,
  withAutoRefinance = false,
  withDeposit = false,
  withNydigNotice = false,
  rewardProgramCode = '00',
  // deprecated
  programDefinitionCode = '00',
  cardIssuingBanks = [CRB]
}) => {
  if (type === NONE) {
    return null;
  }
  if (type === AUTO_FINANCE) {
    return /*#__PURE__*/React.createElement(AutoFinance, {
      publicSiteUrl
    });
  }
  if (type === AUTO_REFINANCE) {
    return /*#__PURE__*/React.createElement(AutoRefinance, {
      publicSiteUrl
    });
  }
  if (type === LENDING_TREE) {
    return /*#__PURE__*/React.createElement(LendingTreeCredit, null);
  }
  return /*#__PURE__*/React.createElement(Text, {
    as: "p",
    size: "sm"
  }, type === ALL_PRODUCTS || type === PERSONAL_LOAN ? /*#__PURE__*/React.createElement(PersonalLoan, {
    publicSiteUrl,
    withAutoRefinance
  }) : null, type === ALL_PRODUCTS ? ' ' : null, type === ALL_PRODUCTS || type === PERSONAL_CREDIT_LINE ? /*#__PURE__*/React.createElement(PersonalCreditLine, {
    publicSiteUrl,
    withNydigNotice,
    cardIssuingBanks,
    programDefinitionCode: programDefinitionCode || rewardProgramCode
  }) : null, type === ALL_PRODUCTS ? ' ' : null, type === ALL_PRODUCTS || type === REWARDS_CHECKING ? /*#__PURE__*/React.createElement(RewardsChecking, {
    withDeposit
  }) : null, type === ALL_PRODUCTS ? ' ' : null, type === ALL_PRODUCTS || type === HOME_IMPROVEMENT_CREDIT_LINE ? /*#__PURE__*/React.createElement(HomeImprovement, null) : null);
};
export default BankNoticeV1;
BankNoticeV1.propTypes = {
  publicSiteUrl: PropTypes.string.isRequired,
  type: PropTypes.oneOf(Object.values(Types)).isRequired,
  withAutoRefinance: PropTypes.bool,
  withDeposit: PropTypes.bool,
  withNydigNotice: PropTypes.bool,
  rewardProgramCode: PropTypes.string,
  // deprecated
  programDefinitionCode: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  cardIssuingBanks: PropTypes.array
};
//# sourceMappingURL=index.js.map